import { useState, FormEvent } from 'react';

export function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    address: '',
    city: '',
    state: '',
    service: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d4ps4s1mma3c958r818g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          phone: '',
          email: '',
          address: '',
          city: '',
          state: '',
          service: '',
          message: ''
        });

      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-16 sm:py-20 bg-[#2D5016] relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'1\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")' }}></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-10 sm:mb-12">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 px-4">
            Get Your Free Quote
          </h2>
          <p className="text-lg sm:text-xl text-white/80">
            We'll respond within 24 hours
          </p>
        </div>

        <div className="bg-white rounded-3xl p-6 sm:p-8 md:p-12 shadow-2xl">
          <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-5 sm:space-y-6">
            <div className="grid md:grid-cols-2 gap-5 sm:gap-6">
              <div>
                <label htmlFor="name" className="block text-sm font-semibold text-gray-700 mb-2">
                  Full Name *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4A7C2C] focus:border-transparent outline-none transition-all text-sm"
                  placeholder="John Smith"
                />
              </div>

              <div>
                <label htmlFor="phone" className="block text-sm font-semibold text-gray-700 mb-2">
                  Phone Number *
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  required
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4A7C2C] focus:border-transparent outline-none transition-all text-sm"
                  placeholder="(443) 555-0123"
                />
              </div>
            </div>

            <div>
              <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                Email Address *
              </label>
              <input
                type="email"
                id="email"
                name="email"
                required
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4A7C2C] focus:border-transparent outline-none transition-all text-sm"
                placeholder="john@example.com"
              />
            </div>

            <div>
              <label htmlFor="address" className="block text-sm font-semibold text-gray-700 mb-2">
                Property Address <span className="text-gray-400 font-normal">(Optional)</span>
              </label>
              <input
                type="text"
                id="address"
                name="address"
                value={formData.address}
                onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4A7C2C] focus:border-transparent outline-none transition-all text-sm"
                placeholder="123 Main St"
              />
            </div>

            <div className="grid md:grid-cols-2 gap-5 sm:gap-6">
              <div>
                <label htmlFor="city" className="block text-sm font-semibold text-gray-700 mb-2">
                  City <span className="text-gray-400 font-normal">(Optional)</span>
                </label>
                <input
                  type="text"
                  id="city"
                  name="city"
                  value={formData.city}
                  onChange={(e) => setFormData({ ...formData, city: e.target.value })}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4A7C2C] focus:border-transparent outline-none transition-all text-sm"
                  placeholder="Owings Mills"
                />
              </div>

              <div>
                <label htmlFor="state" className="block text-sm font-semibold text-gray-700 mb-2">
                  State <span className="text-gray-400 font-normal">(Optional)</span>
                </label>
                <input
                  type="text"
                  id="state"
                  name="state"
                  value={formData.state}
                  onChange={(e) => setFormData({ ...formData, state: e.target.value })}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4A7C2C] focus:border-transparent outline-none transition-all text-sm"
                  placeholder="MD"
                />
              </div>
            </div>

            <div>
              <label htmlFor="service" className="block text-sm font-semibold text-gray-700 mb-2">
                Service Needed *
              </label>
              <select
                id="service"
                name="service"
                required
                value={formData.service}
                onChange={(e) => setFormData({ ...formData, service: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4A7C2C] focus:border-transparent outline-none transition-all text-sm cursor-pointer"
              >
                <option value="">Select a service...</option>
                <option value="Lawn Mowing">Lawn Mowing</option>
                <option value="Mulching">Mulching</option>
                <option value="Fall & Spring Cleanups">Fall & Spring Cleanups</option>
                <option value="Gutter Cleaning">Gutter Cleaning</option>
                <option value="Hardscaping">Hardscaping</option>
                <option value="Paint Jobs">Paint Jobs</option>
                <option value="Drainage Solutions">Drainage Solutions</option>
                <option value="Pressure Washing">Pressure Washing</option>
                <option value="Concrete Work">Concrete Work</option>
                <option value="Snow Removal">Snow Removal</option>
                <option value="Ice Management">Ice Management</option>
                <option value="Yard Restorations">Yard Restorations</option>
                <option value="Tree & Bush Trimming">Tree & Bush Trimming</option>
                <option value="Multiple Services">Multiple Services</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div>
              <label htmlFor="message" className="block text-sm font-semibold text-gray-700 mb-2">
                Project Details *
              </label>
              <textarea
                id="message"
                name="message"
                required
                rows={4}
                maxLength={500}
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4A7C2C] focus:border-transparent outline-none transition-all resize-none text-sm"
                placeholder="Tell us about your landscaping needs..."
              ></textarea>
              <p className="text-xs text-gray-500 mt-1">{formData.message.length}/500 characters</p>
            </div>

            {submitStatus === 'success' && (
              <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-lg">
                <p className="font-semibold text-sm">Thank you! We'll contact you within 24 hours.</p>
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-lg">
                <p className="font-semibold text-sm">Something went wrong. Please call us at 443-398-0720.</p>
              </div>
            )}

            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full bg-[#4A7C2C] text-white px-8 py-4 rounded-full font-bold text-base sm:text-lg hover:bg-[#2D5016] transition-all duration-300 flex items-center justify-center gap-3 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
            >
              {isSubmitting ? (
                <>
                  <i className="ri-loader-4-line animate-spin text-xl"></i>
                  Sending...
                </>
              ) : (
                <>
                  Send Request
                  <i className="ri-arrow-right-line text-xl"></i>
                </>
              )}
            </button>
          </form>

          <div className="mt-8 pt-8 border-t border-gray-200">
            <p className="text-center text-gray-600 mb-4 font-semibold text-sm sm:text-base">Or call us directly:</p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-5 sm:gap-6">
              <a 
                href="tel:443-398-0720"
                className="flex items-center gap-3 text-[#2D5016] font-bold text-lg sm:text-xl hover:text-[#4A7C2C] transition-colors cursor-pointer"
              >
                <i className="ri-phone-fill text-2xl"></i>
                443-398-0720
              </a>
              <a 
                href="mailto:greenerecolandscaping@gmail.com"
                className="flex items-center gap-3 text-[#2D5016] font-semibold text-sm sm:text-base hover:text-[#4A7C2C] transition-colors cursor-pointer break-all"
              >
                <i className="ri-mail-line text-xl"></i>
                greenerecolandscaping@gmail.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
